import { List } from "react-admin";
import { EmptyState } from "../../misc/EmptyState";
import { SearchFilterInput } from "../../inputs/SearchFilterInput";
import { useCurrentDrivingSchoolId } from "../../hooks/useCurrentDrivingSchoolId";
import { VehiclesDataGrid, type VehicleListResource } from "./VehiclesDataGrid";
import { ResponsiveListSurface } from "../../misc/ResponsiveListSurface";

export function VehicleList(props: {
  resource: VehicleListResource;
  noEntriesText?: string;
  noMatchingEntriesText?: string;
}) {
  const { resource, noEntriesText, noMatchingEntriesText } = props;
  const drivingSchoolId = useCurrentDrivingSchoolId();
  const empty = <EmptyState noEntriesText={noEntriesText} noMatchingEntriesText={noMatchingEntriesText} />;

  return (
    <ResponsiveListSurface variant="compactTabContent">
      <List
        title=" " // <-- prevent that the default list title is rendered
        resource={resource}
        // Do not read the vehicles from the Firestore driving_schools document, because the projection
        // into this document might not be in sync with the Postgres database yet (e.g. after a vehicle
        // has been created or updated) ...
        queryOptions={{ meta: { source: "server" } }}
        filter={{ drivingSchoolId }}
        filters={[<SearchFilterInput key="q" source="q" alwaysOn resettable />]}
        actions={false}
        sort={/* initial sort order: */ { field: "name", order: "ASC" }}
        exporter={false}
        empty={empty}
        hasCreate={false}
      >
        <VehiclesDataGrid resource={resource} empty={empty} />
      </List>
    </ResponsiveListSurface>
  );
}
